import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { CREDITS_SLICE } from "./sliceNames";
import { CREDITS_INITIAL_VALUE } from "constants/initialValue";
import { ICreditsState } from "interfaces/redux/reducers";
import { ICreditServiceOption } from "interfaces/Checkout/checkout.interface";

interface IUpdateCreditsServiceOptionPayload {
  credits_service_options: ICreditServiceOption[];
  loading_credit_service_options: boolean;
}

const creditsSlice = createSlice({
  name: CREDITS_SLICE,
  initialState: CREDITS_INITIAL_VALUE,
  reducers: {
    updateCreditsServiceOptionPayload: (
      state: ICreditsState,
      action: PayloadAction<IUpdateCreditsServiceOptionPayload>,
    ) => {
      action.payload.credits_service_options;
      return {
        ...state,
        credits_service_options: action?.payload?.credits_service_options || [],
        loading_credit_service_options: !!action?.payload?.loading_credit_service_options,
      };
    },
  },
});

export const { updateCreditsServiceOptionPayload: actionUpdateCreditsServiceOptionPayload } = creditsSlice.actions;

export default creditsSlice.reducer;
